import { usePatientNotes } from '../../../hooks/usePatientNotes';

interface NotesTabLabelProps {
    patientId: string;
}

// "Patient notes" tab label with a count badge. Reads from the same
// usePatientNotes cache the panel content uses, so it adds no extra fetch.
export function NotesTabLabel({ patientId }: NotesTabLabelProps) {
    const { notes } = usePatientNotes(patientId);
    const count = notes.length;
    return (
        <span className="inline-flex items-center gap-1.5">
            Patient notes
            {count > 0 && (
                <span className="inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-gray-200 text-gray-700 text-[10px] font-bold leading-none">
                    {count}
                </span>
            )}
        </span>
    );
}
